import {makeStore} from "../ducks"
import State from "../models/State"
import {AppProps} from "../App"

export const getStore = (_STATE_?: State) => {
    const state = _STATE_ || getState()
    // reproduce the store used to render the page on server
    const store = makeStore(state)
    return store
}

export const getProps = () => {
    // Read the initial props as set by the server
    const {appProps} = (window as any).ssrClientSettings.plp
    return appProps as AppProps
}

export const getState = () => {
    // Read the state sent with markup
    const {_STATE_} = (window as any).ssrClientSettings.plp
    return _STATE_ as State
}
